<template>
  <div class="detailPage">
    <div class="content line">
      <div class="order_info">
        <p>订单编号：{{ dataItem.orderno }}</p>
        <p>订单类型：{{ dataItem.ordertypestr }}</p>
      </div>
      <div class="block" v-for="(item, index) in orderShopList" :key="index">
        <h1>商品名称：{{ item.cmname }}</h1>
        <div class="txt">
          <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
            {{ label }}
          </p>
        </div>
        <h1>商品数量：{{ item.cmnum }}</h1>
        <div class="warehouse flex-rowl">
          <h1>库源信息：</h1>
          <p v-html="item.msg"></p>
        </div>
        <div class="backLog_wrap" v-if="item.backlog.id">
          <p>
            退款申请工单序号：<span>{{ item.backlog.transaction_id }}</span>
          </p>
          <p>
            退款类型：<span>{{ item.backlog.logtypestr }}</span>
          </p>
          <p>
            退款金额：<span>¥ {{ item.backlog.fee }}</span>
          </p>
          <p>
            退款情况：<span>{{ item.backlog.returnnotestr }}</span>
          </p>
          <p>
            退费原因：<span>{{ item.backlog.reasonidstr }}</span>
          </p>
          <p>
            退款状态：<span>{{ item.backlog.returnstate }}</span>
          </p>
          <p>
            退款审核状态：<span>{{ item.backlog.checkstatestr }}</span>
          </p>
          <p>
            退款属性：<span>{{ item.backlog.returnattrstr }}</span>
          </p>
          <p>
            退款时间：<span>{{ item.backlog.returndate | formatDate }}</span>
          </p>
        </div>

        <!-- <h1>
          商品标价：¥
          {{ item.price }}
        </h1> -->
      </div>
    </div>

    <div class="content line">
      <div class="address_wrap">
        <div class="item flex-rowl">
          <p>收件人：</p>
          <p>
            {{ dataItem.truename }}
            <span
              v-if="dataItem.truename"
              class="copy_box"
              :data-clipboard-text="dataItem.truename"
              @click="handleCopyBtn"
              ><i class="iconfont icon-fuzhi"></i
            ></span>
          </p>
        </div>
        <div class="item flex-rowl">
          <p>收件人联系方式：</p>
          <p>{{ dataItem.cellphone }}
             <span
             v-if="dataItem.cellphone"
              class="copy_box"
              :data-clipboard-text="dataItem.cellphone"
              @click="handleCopyBtn"
              ><i class="iconfont icon-fuzhi"></i
            ></span>
          </p>
        </div>
        <div class="item flex-rowl">
          <p>物流信息：</p>
          <p>{{ dataItem.order_addr }}
             <span
             v-if="dataItem.order_addr"
              class="copy_box"
              :data-clipboard-text="dataItem.order_addr"
              @click="handleCopyBtn"
              ><i class="iconfont icon-fuzhi"></i
            ></span>
          </p>
        </div>
        <div class="item flex-rowl">
          <p>订单状态：</p>
          <p>{{ dataItem.orderstate }}</p>
        </div>
        <div class="item flex-rowl">
          <p>物流类型：</p>
          <p>{{ dataItem.service_company }}</p>
        </div>

        <div class="item flex-rowl">
          <p>发货物流订单号：</p>
          <p>{{ dataItem.service_no }}</p>
        </div>
        <div class="item flex-rowl">
          <p>发货门店：</p>
          <p>{{ dataItem.service_shopstr }}</p>
        </div>
        <!-- <div class="item">
          <p>库源信息：</p>
          <p v-html="dataItem.warehouse"></p>
        </div> -->
      </div>
    </div>
    <div class="status_wrap">
      <div class="block">
        <div class="txt1 flex-between">
          <p>订单物流状态：</p>
          <p class="red">
            {{ dataItem.service_state }}
          </p>
        </div>
        <div class="txt1 flex-between">
          <p>用户是否验收：</p>
          <p class="red">{{ dataItem.isrec == 0 ? "未收货" : "已收货" }}</p>
        </div>
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="goods-bottom-operation flex-rowl">
      <div class="arr" @click="handleReturn">
        <i class="iconfont icon-bottom"></i>
      </div>
      <div
        class="item flex-rowc"
        :class="isNoSend ? 'disable' : ''"
        @click="handleGo(1)"
      >
        配货
      </div>
      <div
        class="item flex-rowc"
        :class="isNoSend ? 'disable' : ''"
        @click="handleGo(2)"
      >
        发货
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getLogisticsDetail, getLogisticsDisList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundDetail",
  data() {
    return {
      id: "",
      dataItem: "",
      orderShopList: "", // 订单商品列表
      shopBacklog: "",
      isNoSend: false,

      orderShopParams: {
        wsid: "",
        pageindex: 1,
        pagesize: 50,
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.orderShopParams.wsid = id;
        this.init(id);
      } else {
        this.$router.back();
      }
    },

    async init(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // 订单数据
      let res1 = await getLogisticsDetail({ id });
      this.dataItem = res1;
      this.shopBacklog = res1.backlog.length > 0 ? res1.backlog[0] : "";
      if (this.dataItem.service_state == "已发货") {
        this.isNoSend = true;
      } else if (
        this.shopBacklog &&
        this.shopBacklog.checkstate != 5 &&
        this.shopBacklog.checkstate != 6
      ) {
        this.isNoSend = true;
      }

      // 订单商品
      let res2 = await getLogisticsDisList(this.orderShopParams);
      if (res2.list.length > 0) {
        res2.list.forEach((v) => {
          v.msg = v.msg != "" ? v.msg.replace(/\|/g, "<br/>") : "";
          v.attr = v.attr && v.attr != "" ? JSON.parse(v.attr) : [];
          v.backlog =
            v.ams_shop_backlog.length > 0 ? v.ams_shop_backlog[0] : "";
        });
      }
      this.orderShopList = res2.list;

      Toast.clear();
    },

    handleReturn() {
      this.$router.back();
    },

    // 跳转页面
    handleGo(type) {
      let { id, dataItem, isNoSend } = this;
      if (dataItem.service_state == "已发货") {
        return;
      }
      if (type == 1 && dataItem.service_state != "已发货" && !isNoSend) {
        // this.$router.push(`/outboundIndex/outboundDistributionList/${id}`);
        this.encryptstringadd("outboundDistributionList", { id });
      } else if (type == 2 && dataItem.service_state != "已发货" && !isNoSend) {
        // this.$router.push(`/outboundIndex/outboundEdit/${id}`);
        this.encryptstringadd("outboundEdit", { id });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.detailPage {
  padding-bottom: 300px;
  .line {
    border-bottom: 9px solid #f5f5f5;
  }
  .content {
    padding: 39px 42px 47px;
    .order_info {
      font-size: 22px;
      color: #3c3c3c;
      margin-bottom: 25px;
      p {
        &:nth-child(2) {
          margin: 15px 0;
        }
      }
    }
    .block {
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 0;
      }
      h1 {
        font-size: 20px;
        color: #3c3c3c;
        margin-bottom: 9px;
      }
      .txt {
        margin-bottom: 19px;
        p {
          font-size: 18px;
          color: #969696;
          line-height: 30px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .warehouse {
        font-size: 20px;
        align-items: flex-start;
        h1 {
          white-space: nowrap;
          line-height: 30px;
        }
        p {
          line-height: 30px;
        }
      }
      .backLog_wrap {
        font-size: 20px;
        p {
          line-height: 30px;
        }
      }
    }
    .price {
      font-size: 24px;
      p {
        &:last-child {
          font-size: 40px;
          span {
            font-size: 24px;
            margin-right: 10px;
          }
        }
      }
    }
    .price_btm {
      margin-top: 50px;
      font-size: 24px;
      p {
        &:last-child {
          font-size: 20px;
          span {
            font-size: 22px;
          }
        }
      }
    }
    .price_other {
      font-size: 24px;
      span {
        font-size: 24px;
        margin-right: 22px;
      }
      .txt {
        margin: 77px 0 50px;
        .red {
          font-size: 40px;
          color: #ee0032;
        }
      }
      .txt1 {
        p {
          &:last-child {
            font-size: 40px;
          }
        }
      }
      .detail_btn {
        height: 40px;
        line-height: 40px;
        margin: 0;
        padding: 0 20px;
        font-size: 18px;
        border: 1px solid #aaaaaa;
        display: inline-block;
        border-radius: 22px;
        margin-top: 29px;
      }
    }
  }
  .address_wrap {
    font-size: 22px;
    .item {
      margin-bottom: 30px;
      align-items: flex-start;
      p {
        &:first-child {
          white-space: nowrap;
          width: 190px;
        }
      }
      .copy_box {
        margin-left: 15px;
        .iconfont {
          font-size: 22px;
        }
      }
    }
    .txt {
      font-size: 20px;
      line-height: 30px;
    }
  }
  .pay_wrap {
    padding: 42px 57px 150px;
    font-size: 24px;
    box-sizing: border-box;
    .tit {
      margin-bottom: 70px;
    }
    .block {
      font-size: 22px;
      color: #aaaaaa;
      margin-bottom: 59px;
      padding-left: 39px;
      p {
        margin-bottom: 35px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .mark {
      font-size: 22px;
      padding-left: 39px;
      p {
        color: #aaaaaa;
        margin-top: 28px;
      }
    }
  }
  .status_wrap {
    padding: 55px 58px 0;
    font-size: 22px;
    color: #3c3c3c;
    .red {
      font-size: 30px;
      color: #ee0032;
    }
    .block {
      margin-bottom: 110px;
    }
    .txt1 {
      margin-bottom: 25px;
    }
  }
  .goods-bottom-operation {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    font-size: 24px;
    color: #000000;
    padding: 50px 73px 115px 46px;
    .arr {
      transform: rotate(90deg);
      .iconfont {
        font-size: 40px;
      }
    }
    .item {
      width: 180px;
      &.disable {
        color: #969696;
      }
    }
  }
}
</style>